import t from "babel-plugin-yate/macro";
import { get, flattenDeep } from "lodash-es";
import { makeApiCall } from "../lib/api/helpers";
import { sortListByKey } from "../lib/misc";
import {
  createLendingRequestApi,
  dismissLendingRequestApi,
  getLendingRequestsApi,
  getLendingRequestApi,
  getNomenclaturesApi,

  getActivitiesApi,
  getApplicationDocumentApi,
  getCivilStatusApi,
  getContactMethodsApi,
  getAccountStatementDeliveryModeApi,
  getMarketingContactMethodsApi,
  getEducationApi,
  getEmploymentStatusesApi,
  getEstimatedOffersApi,
  getInstallmentsApi,
  getLendingRequestDocumentsApi,
  getLendingRequestHistoryApi,
  getLendingRequestCommentsApi,
  getLendingRequestStatusOffersApi,
  getLendingRequestOfferContractApi,
  getOccupationApi,
  getOffersApi,
  getOfferDocumentApi,
  getScoreApi,
  getPropertyStatusApi,
  getFundingSourceApi,
  getRegionsApi,
  getCitiesApi,
  getPostalCodesApi,
  getSimulatorOfferEstimatesApi,
  ocrApi,
  postCiApi,
  postClientDetailsApi,
  postBankAccountApi,
  postFileApi,
  postFileBackOfficeApi,
  getFileApi,
  postLendingRequestCommentsApi,
  postLendingRequestOfferContractApi,
  processOffersApi,
  setLendingRequestOfferStatusApi,
  setLendingRequestGoodToFinanceStatusApi,
  verifyCbAnafApi,
  sendEmailMobileApi,
  sendEmailNotificationApi,
  esignInitApi,
  esignAuthCodeApi,
  esignResendAuthCodeApi,
  esignPostAuthApi,
  postCheckValidatedEmailApi,
  postValidateEmailApi,
  postValidateEmailCodeApi,
  getAddressTypeApi,
} from "../lib/api";

export const CREATE_LENDING_REQUEST = "request/CREATE_LENDING_REQUEST";
export const DISMISS_LENDING_REQUEST = "request/DISMISS_LENDING_REQUEST";
export const GET_LENDING_REQUESTS = "request/GET_LENDING_REQUESTS";
export const GET_LENDING_REQUEST = "request/GET_LENDING_REQUEST";
export const GET_NOMENCLATURES = "request/GET_NOMENCLATURES";

export const DOWNLOAD_CONSENTS = "request/DOWNLOAD_CONSENTS";
export const GET_ACTIVITIES = "request/GET_ACTIVITIES";
export const GET_APPLICATION_DOCUMENT = "request/GET_APPLICATION_DOCUMENT";
export const GET_OFFER_DOCUMENT = "request/GET_OFFER_DOCUMENT";
export const GET_CIVIL_STATUS = "request/GET_CIVIL_STATUS";
export const GET_CONTACT_METHODS = "request/GET_CONTACT_METHODS";
export const GET_ACCOUNT_STATEMENT_DELIVERY_MODE =
  "request/GET_ACCOUNT_STATEMENT_DELIVERY_MODE";
export const GET_MARKETING_CONTACT_METHODS =
  "request/GET_MARKETING_CONTACT_METHODS";
export const GET_DYNAMIC_DOCUMENT = "request/GET_DYNAMIC_DOCUMENT";
export const GET_EDUCATION = "request/GET_EDUCATION";
export const GET_EMPLOYMENT_STATUSES = "request/GET_EMPLOYMENT_STATUSES";
export const GET_ESTIMATED_OFFERS = "request/GET_ESTIMATED_OFFERS";

export const GET_LENDING_REQUEST_ASSIGNABLE_USERS =
  "request/GET_LENDING_REQUEST_ASSIGNABLE_USERS";
export const GET_LENDING_REQUEST_DOCUMENTS =
  "request/GET_LENDING_REQUEST_DOCUMENTS";
export const GET_LENDING_REQUEST_HISTORY =
  "request/GET_LENDING_REQUEST_HISTORY";
export let GET_LENDING_REQUEST_COMMENTS =
  "request/GET_LENDING_REQUEST_COMMENTS";
export let GET_LENDING_REQUEST_COMMENTS_DESTINATION =
  "request/GET_LENDING_REQUEST_COMMENTS_DESTINATION";
export const GET_LENDING_REQUEST_OFFER_CONTRACT =
  "request/GET_LENDING_REQUEST_OFFER_CONTRACT";

export const GET_OCCUPATION = "request/GET_OCCUPATION";
export const GET_INSTALLMENTS = "request/GET_INSTALLMENTS";
export const GET_OFFERS = "request/GET_OFFERS";
export const GET_SCORE = "request/GET_SCORE";

export const GET_PROPERTY_STATUS = "request/GET_PROPERTY_STATUS";
export const GET_FUNDING_SOURCE = "request/GET_FUNDING_SOURCE";
export const GET_REGIONS = "request/GET_REGIONS";
export const GET_CITIES = "request/GET_CITIES";
export const GET_POSTAL_CODES = "request/GET_POSTAL_CODES";
export const GET_SIMULATOR_OFFER_ESTIMATES =
  "request/GET_SIMULATOR_OFFER_ESTIMATES";
export const POST_CI = "request/POST_CI";
export const POST_CLIENT_DETAILS = "request/POST_CLIENT_DETAILS";
export const POST_BANK_ACCOUNT = "request/POST_BANK_ACCOUNT";
export const POST_FILE = "request/POST_FILE";
export const GET_FILE = "request/GET_FILE";
export let POST_LENDING_REQUEST_COMMENTS =
  "request/POST_LENDING_REQUEST_COMMENTS";
export const POST_LENDING_REQUEST_OFFER_CONTRACT =
  "request/POST_LENDING_REQUEST_OFFER_CONTRACT";
export const POST_OCR = "request/POST_OCR";
export const PROCESS_OFFERS = "request/PROCESS_OFFERS";
export const SET_LENDING_REQUEST_OFFER_STATUS =
  "request/SET_LENDING_REQUEST_OFFER_STATUS";
export const SET_LENDING_REQUEST_GOOD_TO_FINANCE_STATUS =
  "request/SET_LENDING_REQUEST_GOOD_TO_FINANCE_STATUS";
export const VERIFY_CB_ANAF = "request/VERIFY_CB_ANAF";
export const SEND_EMAIL_NOTIFY = "request/SEND_EMAIL_NOTIFY";
export const ESIGN_INIT = "request/ESIGN_INIT";
export const ESIGN_AUTH_CODE = "request/ESIGN_AUTH_CODE";
export const ESIGN_RESEND_AUTH_CODE = "request/ESIGN_RESEND_AUTH_CODE";
export const ESIGN_POST_AUTH = "request/ESIGN_POST_AUTH";
export const CHECK_VALIDATED_CONTACT = "request/CHECK_VALIDATED_CONTACT";
export const VALIDATE_CONTACT = "request/VALIDATE_CONTACT";
export const VALIDATE_CODE = "request/VALIDATE_CODE";
export const GET_ADDRESS_TYPE = "request/GET_ADDRESS_TYPE";

export const createLendingRequest = (payload, options) => async (dispatch, getState) => {
  return makeApiCall({
    action: CREATE_LENDING_REQUEST,
    dispatch,
    getState,
    spinner: true,
    apiCall: createLendingRequestApi,
    apiArgs: [payload, options],
  });
};

export const dismissLendingRequest = (payload, options) => async (dispatch, getState) => {
  return makeApiCall({
    action: DISMISS_LENDING_REQUEST,
    dispatch,
    getState,
    spinner: true,
    apiCall: dismissLendingRequestApi,
    apiArgs: [payload, options],
  });
};

export const getLendingRequests = (filters) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUESTS,
      dispatch,
      getState,
      apiCall: getLendingRequestsApi,
      apiArgs: [filters],
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequest = (requestId) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_LENDING_REQUEST,
    dispatch,
    getState,
    apiCall: getLendingRequestApi,
    apiArgs: [requestId],
    formatResponse: (response) => response.data.data,
  });
};


export const getNomenclatures = (type) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_NOMENCLATURES,
    dispatch,
    getState,
    apiCall: getNomenclaturesApi,
    apiArgs: [type],
    formatResponse: (response) => {
      return {
        [type]: response.data.data
      };
    },
  });
};

export const setLendingRequestOfferStatus =
  (statusType, requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: SET_LENDING_REQUEST_OFFER_STATUS,
      dispatch,
      getState,
      apiCall: setLendingRequestOfferStatusApi,
      apiArgs: [statusType, requestId],
      formatResponse: (response) => response.data.data,
    });
  };

export const setLendingRequestGoodToFinanceStatus =
  (requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: SET_LENDING_REQUEST_GOOD_TO_FINANCE_STATUS,
      dispatch,
      getState,
      apiCall: setLendingRequestGoodToFinanceStatusApi,
      apiArgs: [requestId],
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequestOfferContract =
  (offerId) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUEST_OFFER_CONTRACT,
      dispatch,
      getState,
      apiCall: getLendingRequestOfferContractApi,
      apiArgs: [offerId],
    });
  };

export const postLendingRequestOfferContract =
  (offerId) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_LENDING_REQUEST_OFFER_CONTRACT,
      dispatch,
      getState,
      apiCall: postLendingRequestOfferContractApi,
      apiArgs: [offerId],
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequestDocuments =
  (requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUEST_DOCUMENTS,
      dispatch,
      getState,
      apiCall: getLendingRequestDocumentsApi,
      apiArgs: [requestId],
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequestHistory =
  (requestId, params = {}) =>
  async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUEST_HISTORY,
      dispatch,
      getState,
      apiCall: getLendingRequestHistoryApi,
      apiArgs: [requestId, params],
      returnResponse: true,
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequestComments =
  (requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUEST_COMMENTS,
      dispatch,
      getState,
      apiCall: getLendingRequestCommentsApi,
      apiArgs: [requestId],
      formatResponse: (response) => response.data.data,
    });
  };

export const getLendingRequestStatusOffers =
  (requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_LENDING_REQUEST_COMMENTS_DESTINATION,
      dispatch,
      getState,
      apiCall: getLendingRequestStatusOffersApi,
      apiArgs: [requestId],
      formatResponse: (response) => response.data.data,
    });
  };

export const postLendingRequestComments =
  (payload, requestId, offerId) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_LENDING_REQUEST_COMMENTS,
      dispatch,
      getState,
      apiCall: postLendingRequestCommentsApi,
      apiArgs: [payload, requestId, offerId],
      formatResponse: (response) => response.data.data,
    });
  };

export const postOcr = (payload) => async (dispatch, getState) => {
  return makeApiCall({
    action: POST_OCR,
    dispatch,
    getState,
    apiCall: ocrApi,
    apiArgs: [payload],
    formatResponse: (response) => response.data.data,
  });
};

export const postFile = (payload, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: POST_FILE,
    dispatch,
    getState,
    apiCall: postFileApi,
    apiArgs: [payload, uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const postFileBackOffice =
  (payload, uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_FILE,
      dispatch,
      getState,
      apiCall: postFileBackOfficeApi,
      apiArgs: [payload, uuid],
      formatResponse: (response) => response.data.data,
    });
  };

export const getFile = (type, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_FILE,
    dispatch,
    getState,
    apiCall: getFileApi,
    apiArgs: [type, uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const verifyCbAnaf = (requestId) => async (dispatch, getState) => {
  return makeApiCall({
    action: VERIFY_CB_ANAF,
    dispatch,
    getState,
    spinner: true,
    apiCall: verifyCbAnafApi,
    apiArgs: [requestId],
    formatResponse: (response) => response.data.data,
  });
};

export const getApplicationDocument =
  (requestId) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_APPLICATION_DOCUMENT,
      dispatch,
      getState,
      apiCall: getApplicationDocumentApi,
      apiArgs: [requestId],
    });
  };

export const getOfferDocument =
  (offerId, uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_OFFER_DOCUMENT,
      dispatch,
      getState,
      apiCall: getOfferDocumentApi,
      apiArgs: [offerId, uuid, payload],
    });
  };


export const getRegions = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_REGIONS,
    dispatch,
    getState,
    apiCall: getRegionsApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getCities = (regionId, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_CITIES,
    dispatch,
    getState,
    apiCall: getCitiesApi,
    apiArgs: [regionId, uuid],
    formatResponse: (response) => {
      return {
        [regionId]: sortListByKey(response.data.data)
      };
    },
  });
};

export const getPostalCodes = (localityId, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_POSTAL_CODES,
    dispatch,
    getState,
    apiCall: getPostalCodesApi,
    apiArgs: [localityId, uuid],
    formatResponse: (response) => ({
      [localityId]: flattenDeep(response.data.data),
    }),
  });
}

export const postCi = (payload, credit_request_id) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: POST_CI,
    dispatch,
    getState,
    spinner: true,
    apiCall: postCiApi,
    apiArgs: [payload, credit_request_id],
  });
};

export const postClientDetails = (payload, credit_request_id) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: POST_CLIENT_DETAILS,
    dispatch,
    getState,
    spinner: true,
    apiCall: postClientDetailsApi,
    apiArgs: [payload, credit_request_id],
    formatResponse: (response) => response.data.data,
  });
};

export const postBankAccount = (payload, credit_request_id) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: POST_BANK_ACCOUNT,
    dispatch,
    getState,
    spinner: true,
    apiCall: postBankAccountApi,
    apiArgs: [payload, credit_request_id],
    formatResponse: (response) => response.data.data,
  });
};

export const getOccupation = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_OCCUPATION,
    dispatch,
    getState,
    apiCall: getOccupationApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getInstallments = (locationId, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_INSTALLMENTS,
    dispatch,
    getState,
    apiCall: getInstallmentsApi,
    apiArgs: [locationId, uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getCivilStatus = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_CIVIL_STATUS,
    dispatch,
    getState,
    apiCall: getCivilStatusApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getEducation = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_EDUCATION,
    dispatch,
    getState,
    apiCall: getEducationApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getPropertyStatus = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_PROPERTY_STATUS,
    dispatch,
    getState,
    apiCall: getPropertyStatusApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getFundingSource = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_FUNDING_SOURCE,
    dispatch,
    getState,
    apiCall: getFundingSourceApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getEmploymentStatuses = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_EMPLOYMENT_STATUSES,
    dispatch,
    getState,
    apiCall: getEmploymentStatusesApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const processOffers = (payload) => async (dispatch, getState) => {
  return makeApiCall({
    action: PROCESS_OFFERS,
    dispatch,
    getState,
    apiCall: processOffersApi,
    apiArgs: [payload],
    formatResponse: (response) => response.data.data,
  });
};

export const getOffers = (payload) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_OFFERS,
    dispatch,
    getState,
    apiCall: getOffersApi,
    apiArgs: [payload],
    formatResponse: (response) => response.data.data.offers,
  });
};

export const getSimulatorOfferEstimates = (payload) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: GET_SIMULATOR_OFFER_ESTIMATES,
    dispatch,
    getState,
    apiCall: getSimulatorOfferEstimatesApi,
    apiArgs: [payload],
    formatResponse: (response) => ({
      offers: Object.entries(get(response, "data.data.offers", {})).map(
        ([offerType, offerData], index) => {
          let type = "";
          let title = "";
          let description = t`According to income`;

          switch (offerType) {
            case "maximum_amount": {
              type = "maximumAmount";
              title = t`Maximum amount`;
              break;
            }
            case "maximum_amount_period": {
              type = "maximumInstalments";
              title = t`Maximum duration`;
              break;
            }
            case "requested": {
              type = "requested";
              title = t`Requested offer`;
              break;
            }
            default:
              type = "default";
              title = t`Oferta`;
          }

          return {
            id: index,
            type,
            title,
            description,
            dae: offerData.dae,
            installments: offerData.installments,
            pmt: offerData.pmt,
            amount: offerData.loan_amount,
            interest: offerData.interest,
            totalAmount: offerData.total_credit_amount,
          };
        }
      ),
    }),
  });
};

export const getEstimatedOffers = (payload) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_ESTIMATED_OFFERS,
    dispatch,
    getState,
    apiCall: getEstimatedOffersApi,
    apiArgs: [payload],
    formatResponse: (response) => ({
      offers: Object.entries(get(response, "data.data.offers", {})).map(
        ([offerType, offerData], index) => {
          let type = "";
          let title = "";
          let description = t`According to income`;

          switch (offerType) {
            case "maximum_amount": {
              type = "maximumAmount";
              title = t`Maximum amount`;
              break;
            }
            case "maximum_amount_period": {
              type = "maximumInstalments";
              title = t`Maximum duration`;
              break;
            }
            case "requested": {
              type = "requested";
              title = t`Requested offer`;
              break;
            }
            default:
              type = "default";
              title = t`Oferta`;
          }

          return {
            id: index,
            type,
            title,
            description,
            dae: offerData.dae,
            installments: offerData.installments,
            pmt: offerData.pmt,
            amount: offerData.loan_amount,
            interest: offerData.interest,
            totalAmount: offerData.total_credit_amount,
            financialInstitute: offerData.financial_institute,
          };
        }
      ),
    }),
  });
};

export const getActivities = (payload, uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_ACTIVITIES,
    dispatch,
    getState,
    apiCall: getActivitiesApi,
    apiArgs: [payload, uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getContactMethods = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_CONTACT_METHODS,
    dispatch,
    getState,
    apiCall: getContactMethodsApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getAccountStatementDeliveryMode = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_ACCOUNT_STATEMENT_DELIVERY_MODE,
    dispatch,
    getState,
    apiCall: getAccountStatementDeliveryModeApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getMarketingContactMethods = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_MARKETING_CONTACT_METHODS,
    dispatch,
    getState,
    apiCall: getMarketingContactMethodsApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const sendEmailMobile = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: SEND_EMAIL_NOTIFY,
    dispatch,
    getState,
    apiCall: sendEmailMobileApi,
    apiArgs: [uuid],
  });
};

export const sendEmailNotification = (requestId) => async (dispatch, getState) => {
  return makeApiCall({
    action: SEND_EMAIL_NOTIFY,
    dispatch,
    getState,
    apiCall: sendEmailNotificationApi,
    apiArgs: [requestId],
  });
};

export const esignInit = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_INIT,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignInitApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data,
  });
};

export const getScore = (payload) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_SCORE,
    dispatch,
    getState,
    alert: false,
    apiCall: getScoreApi,
    apiArgs: [payload],
    formatResponse: (response) => response.data,
  });
};

export const esignAuthCode = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_AUTH_CODE,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignAuthCodeApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data,
  });
};

export const esignResendAuthCode = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_RESEND_AUTH_CODE,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignResendAuthCodeApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data,
  });
};
export const esignPostAuth = (uuid, code) => async (dispatch, getState) => {
  return makeApiCall({
    action: ESIGN_POST_AUTH,
    dispatch,
    getState,
    alert: false,
    spinner: true,
    apiCall: esignPostAuthApi,
    apiArgs: [uuid, code],
    formatResponse: (response) => response.data,
  });
};

export const postCheckValidatedEmail = (uuid, payload) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: CHECK_VALIDATED_CONTACT,
    dispatch,
    getState,
    alert: false,
    apiCall: postCheckValidatedEmailApi,
    apiArgs: [uuid, payload],
  });
};

export const postValidateEmail = (uuid, payload) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: VALIDATE_CONTACT,
    dispatch,
    getState,
    alert: false,
    apiCall: postValidateEmailApi,
    apiArgs: [uuid, payload],
    formatResponse: (response) => response,
  });
};

export const postValidateEmailCode = (uuid, payload) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: VALIDATE_CODE,
    dispatch,
    getState,
    alert: false,
    apiCall: postValidateEmailCodeApi,
    apiArgs: [uuid, payload],
    formatResponse: (response) => response.status,
  });
};

export const getAddressType = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_ADDRESS_TYPE,
    dispatch,
    getState,
    apiCall: getAddressTypeApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

const initialState = {
  regions: null,
  cities: {},
  postalCodes: null,
  addressType: null,
  productCategories: null,
  occupation: null,
  civilStatus: null,
  education: null,
  propertyStatus: null,
  fundingSource: null,
  employmentStatuses: null,
  activities: null,
  assignableUsers: null,
  contactMethods: null,
  nomenclatures: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_REGIONS}_SUCCESS`:
      return { ...state, regions: action.payload };

    case `${GET_CITIES}_SUCCESS`: {
      return {
        ...state,
        cities: {
          ...state.cities,
          ...action.payload,
        },
      };
    }
    case `${GET_POSTAL_CODES}_SUCCESS`: {
      return {
        ...state,
        postalCodes: {
          ...state.postalCodes,
          ...action.payload,
        },
      };
    }

    case `${GET_LENDING_REQUEST_ASSIGNABLE_USERS}_SUCCESS`:
      return { ...state, assignableUsers: action.payload };
    case `${GET_NOMENCLATURES}_SUCCESS`:
      return {
        ...state,
        nomenclatures: {
          ...state.nomenclatures,
          ...action.payload,
        },
      };
    case `${GET_OCCUPATION}_SUCCESS`:
      return { ...state, occupation: action.payload };
    case `${GET_CIVIL_STATUS}_SUCCESS`:
      return { ...state, civilStatus: action.payload };
    case `${GET_EDUCATION}_SUCCESS`:
      return { ...state, education: action.payload };
    case `${GET_PROPERTY_STATUS}_SUCCESS`:
      return { ...state, propertyStatus: action.payload };
    case `${GET_FUNDING_SOURCE}_SUCCESS`:
      return { ...state, fundingSource: action.payload };
    case `${GET_EMPLOYMENT_STATUSES}_SUCCESS`:
      return { ...state, employmentStatuses: action.payload };
    case `${GET_ACTIVITIES}_SUCCESS`:
      return {
        ...state,
        activities: {
          ...state.activities,
          [`${action.args[0]}`]: action.payload,
        },
      };
    case `${GET_CONTACT_METHODS}_SUCCESS`:
      return { ...state, contactMethods: action.payload };
    case `${GET_ACCOUNT_STATEMENT_DELIVERY_MODE}_SUCCESS`:
      return { ...state, accountStatementDeliveryMode: action.payload };
    case `${GET_MARKETING_CONTACT_METHODS}_SUCCESS`:
      return { ...state, marketingContactMethods: action.payload };
    case `${GET_ADDRESS_TYPE}_SUCCESS`:
      return { ...state, addressType: action.payload };
    default:
      return state;
  }
};
